import React from 'react';
import PropTypes from 'prop-types';

import Tab from '../../../components/Tab';
import { getYearFromTimestamp } from '../../../utils/timestamp';

const MajorGroup = ({ group }) => (
  <ul className="major-group">
    <h5 className="major-group-header" tabIndex={0}>
      {group.areaOfStudy}
    </h5>
    {group.programs.map(program => (
      <li key={program.majorName} tabIndex={0}>
        {program.majorName}
      </li>
    ))}
  </ul>
);

class Majors extends React.PureComponent {
  static propTypes = {
    searchInputValue: PropTypes.string,
    majors: PropTypes.arrayOf(PropTypes.object),
    lastUpdatedMajor: PropTypes.number,
    labels: PropTypes.shape({
      degreeOfferings: PropTypes.string,
      searchByKeyword: PropTypes.string,
      searchPlaceholder: PropTypes.string,
      footer: PropTypes.string,
    }),
    degreesOfferedFilter: PropTypes.string,
    degreeFilterOptions: PropTypes.arrayOf(PropTypes.object),
    onKeywordChange: PropTypes.func,
    onDegreeOfferingChange: PropTypes.func,
  };

  static defaultProps = {
    majors: [],
  };

  constructor(props) {
    super(props);

    const { degreesOfferedFilter } = props;

    this.state = {
      selectedBubble: degreesOfferedFilter ? degreesOfferedFilter : 'all',
    };
  }

  handleClick = ({ target }) => {
    const degreeFilter = target.getAttribute('data-value');

    this.setState({
      selectedBubble: degreeFilter,
    });

    this.props.onDegreeOfferingChange(degreeFilter);
  };

  handleKeyPress = ({ key, target }) => {
    /* istanbul ignore else */
    if (key === 'Enter') {
      const degreeFilter = target.getAttribute('data-value');

      this.setState({
        selectedBubble: degreeFilter,
      });

      this.props.onDegreeOfferingChange(degreeFilter);
    }
  };

  render() {
    const {
      majors,
      lastUpdatedMajor,
      labels,
      degreeFilterOptions,
      onKeywordChange,
    } = this.props;
    const { selectedBubble } = this.state;

    return (
      <Tab.Pane className="majors">
        <div className="filters">
          <div className="filter degree-offerings">
            <label tabIndex={0}>{labels.degreeOfferings}</label>
            <div className="bubbles">
              <div
                className={`bubble${selectedBubble === 'all' ? ' selected' : ''}`}
                data-value="all"
                tabIndex={0}
                onClick={this.handleClick}
                onKeyPress={this.handleKeyPress}
              >
                All
              </div>
              {degreeFilterOptions.map(option => (
                <div
                  key={option.value}
                  data-value={option.value}
                  className={`bubble${
                    selectedBubble === option.value ? ' selected' : ''
                  }`}
                  tabIndex={0}
                  onClick={this.handleClick}
                  onKeyPress={this.handleKeyPress}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
          <div className="filter search">
            <label tabIndex={0}>{labels.searchByKeyword}</label>
            <input
              data-type="majors"
              placeholder={labels.searchPlaceholder}
              onChange={onKeywordChange}
              defaultValue={this.props.searchInputValue}
            />
          </div>
        </div>
        <div className="list-container">
          {majors.map(group => (
            <MajorGroup key={group.areaOfStudy} group={group} />
          ))}
        </div>
        <div className="major-footer" tabIndex={0}>
          {`${labels.footer}${getYearFromTimestamp(lastUpdatedMajor)}`}
        </div>
      </Tab.Pane>
    );
  }
}

export default Majors;
